export const selectIsTeamBlockedFromPayments = (state) => state.canAcceptPayment.data === false;
